import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

interface ServiceDetailHeroProps {
  data: {
    category: string;
    title: string;
    description: string;
    image: string;
  };
}

const ServiceDetailHero = ({ data }: ServiceDetailHeroProps) => {
  const scrollToContact = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  return (
    <section className="relative pt-32 pb-16 bg-gradient-to-br from-[#007dff]/5 via-white to-[#007dff]/5 overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-0 w-96 h-96 bg-[#007dff]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#007dff]/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-8">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="font-poppins font-semibold text-[12px] text-[#007dff] uppercase tracking-wider mb-3"
            >
              {data.category}
            </motion.p>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="font-poppins font-bold text-3xl lg:text-4xl text-gray-900 mb-4 leading-tight"
            >
              {data.title}
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="font-poppins text-base text-gray-600 mb-6 leading-relaxed"
            >
              {data.description}
            </motion.p>

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="flex flex-wrap gap-4"
            >
              <button
                onClick={scrollToContact}
                className="px-6 py-2.5 bg-gradient-to-r from-[#007dff] to-[#0066dd] text-white text-[14px] font-semibold rounded-xl hover:shadow-xl hover:shadow-[#007dff]/30 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 active:scale-95 font-poppins"
              >
                Teklif Al
              </button>
              <Link
                to="/iletisim"
                className="px-6 py-2.5 bg-white text-[#007dff] text-[14px] font-semibold rounded-xl border-2 border-[#007dff] hover:bg-[#007dff] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105 active:scale-95 font-poppins"
              >
                İletişime Geç
              </Link>
            </motion.div>
          </motion.div>

          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={data.image}
                alt={data.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDetailHero;
